import {forEach} from 'lodash';
import ProfilesService from 'top20common/distribution/services/profiles';

export default {
  fetchTokensAction(context) {
    context.commit('mutateTokensLoadingState', true);
    return new Promise((resolve, reject) => {
      ProfilesService.getTokens()
        .then(response => {
          context.commit('setTokensListState', response.data.results);
          context.commit('setTokensMetaState', response.data.meta);
          context.commit('mutateTokensErrorState', null);
          context.commit('mutateTokensLoadingState', false);
          resolve(response.data.results);
        })
        .catch(error => {
          let errors = [];
          forEach(error.response.data.errors, value => {
            errors.push(value[0]);
          });
          context.commit('mutateTokensLoadingState', false);
          context.commit('mutateTokensErrorState', errors.join('. '));
        });
    });
  }
};
